// @flow
import { isMobileOnly } from 'react-device-detect';

export const NOTIFICATION_DEBOUNCE = 2000;
export const NOTIFICATION_TIMEOUT = 2000;

// official should be 3 hours
export const PURGE_TIMEOUT = 1000 * 60 * 60 * 3;
// 15 mins
export const IDLE_TIMEOUT = 1000 * 60 * 15;

export const OTHERS_VALUE = 'Other（その他）';

export const OTHER_CATEGORY_VALUE = 'その他';

export const OTHER_CATEGORY = 'その他サービス';

export const productTypes = [
  '物品販売',
  '物品販売（定期購入）',
  'デジタルコンテンツ',
  'デジタルコンテンツ（定期課金）',
  'サービス・役務',
  'サービス・役務（定期課金）',
];

export const cartSystems = [
  'Shopify（ショッピファイ）',
  'Accept（アセプト）',
  'AMS（エーエムエス）',
  'BASE（ベイス）',
  'BBF（ビービーエフ）',
  'BeSHOP(ビショップ)',
  'Cafe24（カフェ24）',
  'CLONA （クローナ）',
  'ColorMeShop（カラーミーショップ）',
  'Commerce21（コマース21）',
  'CS-Cart（シーエスカート）',
  'Diamond head（ダイアモンドヘッド）',
  'Direct In（ダイレクトイン）',
  'e-shopsカートS（イーショップスカートエス）',
  'ebisumart（エビスマート）',
  'EC Direct（イーシーダイレクト）',
  'EC-Connect+（イーシーコネクトプラス）',
  'EC-CUBE 2.X（イーシーキューブ）',
  'EC-CUBE 3.X（イーシーキューブ）',
  'EC-CUBE 4.X（イーシーキューブ）',
  'EC-Eyes（イーシーアイズ）',
  'ecbeing（イーシービーイング）',
  'ecforce（イーシーフォース）',
  'ecOrigins（イーシーオリジン）',
  'eltexDC（エルテックスディーシー）',
  'F.ACE（フェイス）',
  'Fashion-Co-Lab.（ファッションコラボ）',
  'FC2（エフシーツー）',
  'Full Scratch（フルスクラッチ/自社開発）',
  'futureshop（フューチャーショップ）',
  'GMOクラウドEC（ジーエムオークラウドイーシー）',
  'HIT-MALL（ヒットモール）',
  'ITFOReC（アイティフォレック）',
  'Lexica（レキシカ）',
  'Lineup（ラインナップ）',
  'Live kit（ライブキット）',
  'MAGASEEK EC Solutions（マガシークイーシーソリューション）',
  'Magento（マジェント）',
  'MakeShop（メイクショップ）',
  'MODD（エム・オー・ディ・ディ）',
  'marble（マーブル）',
  "Omni-Base for DIGITAL'ATELIER（オムニベースフォーデジタラトリエ）",
  'PayPal（ペイパル）',
  'Salesnauts（セールズノーツ）',
  'Salesforce Commerce Cloud（セールスフォースコマースクラウド）',
  'shopserve（ショップサーブ）',
  'SI Web Shopping（エス・アイ ウェブショッピング）',
  'SNAPEC（スナップイーシー）',
  'SoftStepsEC（ソフトステップスイーシー）',
  'SOLEIL（ソレイユ）',
  'Stripe（ストライプ）',
  'W2 Unified（ダブリューツーユニファイド）',
  'WelCart（ウェルカート）',
  'WISECART（ワイズカート）',
  'Wix（ウィックス）',
  'WooCommerce（ウーコマース）',
  'おちゃのこネット',
  'かーるく満席',
  'サブスクストア',
  'まちスタ（ユニエイム）',
  'メルカート',
  'W2 Repeat（ダブリューツーリピート）',
  'リピスト（PRECS/プレックス）',
  'スマレジEC・リピート',
  '予約プロプラス',
];

export const paymentServices = [
  'AXES Payment',
  'elepay',
  'GMOペイメントゲートウェイ',
  'PAYGENT',
  'SB Payment Service',
  'Smart Billing Service',
  'UNIVA Paycast',
  'VeriTrans',
  'ZEUS',
  'アナザーレーン',
  'ソニーペイメントサービス',
  'テレコムクレジット',
  'ルミーズ',
  '佐川フィナンシャル',
  // 'その他（複数利用含む）',
];

export const loadingTypes: { [string]: string } = {
  BIG: 'big',
  REGULAR: 'regular',
};

export const paymentStatusMap: { [string]: string } = {
  CREATED: 'created',
  AUTHENTICATED: 'authenticated',
  AUTHORIZED: 'authorized',
  PENDING: 'pending',
  REJECTED: 'rejected',
  CLOSED: 'closed',
  // for token
  ACTIVE: 'active',
  FAILED: 'failed',
};

export const requiredBigContractDataTypeMap: { [string]: string } = {
  REGULAR: 'regular',
  NONE: 'none',
};

export const plusFormTypeMap: { [string]: string } = {
  REGULAR: 'regular',
  EXTENDED: 'extended',
  NONE: 'none',
};

export const requiredConsumerDataTypeMap: { [string]: ?string } = {
  REGULAR: 'regular',
  NULL: null,
};

export const categoryLicensesMap = {
  ツアー: ['tour'],
  'ホテル・旅館': ['hotel'],
  医薬品: ['pharmaceuticals'],
  医薬部外品: ['quasidrug1', 'quasidrug2', 'quasidrug3'],
  中古品: ['used'],
};

export const allLicenses = Object.keys(categoryLicensesMap).flatMap(
  (key) => categoryLicensesMap[key]
);

export const maxCSSHeight = 'calc(80vh - 136px)';

export const desktopMaxHeightStyle = isMobileOnly ? undefined : { height: maxCSSHeight };
export const desktopBigMaxHeightStyle = isMobileOnly
  ? undefined
  : { height: 790, maxHeight: maxCSSHeight };

export const REGISTER_URL = process.env.GATSBY_ORGANIC_SUBMIT_ENDPOINT;
export const EMAIL_VERIFICATION_URL = process.env.GATSBY_ORGANIC_VERIFY_EMAIL_ENDPOINT;
export const SAVE_APPLICATION_URL = process.env.GATSBY_ORGANIC_SAVE_ENDPOINT;
export const REGISTER_API_AUTH_HEADER = 'abc'; // TODO replace with reCAPTCHA https://paidy-portal.atlassian.net/browse/BDM-1441

export const TERMS_PERSONAL_INFO_CONSENT_URL = 'https://terms.paidy.com/privacy/';
export const CUSTOMER_SERVICE_INQUIRY_FORM_URL =
  'https://cs-support.paidy.com/support/tickets/new?_gl=1*1qd7yuw*_ga*MjA5ODIwODU0OC4xNjk0NzQ5NTcw*_ga_BY9KVJNH1N*MTcxNzcxNjMwNC4zMzMuMS4xNzE3NzE2MzQzLjIxLjAuMA';

export default {
  loadingTypes,
  paymentStatusMap,
  requiredBigContractDataTypeMap,
  plusFormTypeMap,
  requiredConsumerDataTypeMap,
  maxCSSHeight,
  desktopMaxHeightStyle,
};
